import _ from 'lodash';

export function buildSudokuData(postProcess, initialData) {
    let data = {
        cells: []
    };

    for(var i = 0; i < 81; i++) {
        var cell = {
            isGiven: initialData ? initialData[i] > 0 : false,
            number: initialData ? initialData[i] : 0,
            innerPencils: initialData && initialData[i] ? [] : [],
            outerPencils: initialData && initialData[i] ? [] : [],
            highlight: "",
            obstacle: "",
            isSelected: false,
            additionalData: {},
            isCompleted: false
        };
        data.cells.push(cell);
    }
    
    setDataFunctions(data);

    if(postProcess) {
        postProcess(data);
    }
    return data;
}

export function setDataFunctions(data) {
    data.getCell = function(col, row) {
        return this.cells[(col-1) + 9*(row-1)];
    }
    for(var i = 0; i < 81; i++) {
        setCellFunctions(data.cells[i]);
    }
}

export function setCellFunctions(cell) {
    cell.addInnerPencil = function(pencil) {
        if(!this.hasInnerPencil(pencil) && this.number == 0) {
            this.innerPencils.add(pencil);
        }
    };
    cell.removeInnerPencil = function(pencil) {
        const index = this.innerPencils.indexOf(pencil);
        if(index > -1) {
            this.innerPencils.splice(index, 1);
        }
    };
    cell.hasInnerPencil = function(pencil) {
        return this.innerPencils.indexOf(pencil) != -1;
    };
    cell.addOuterPencil = function(pencil) {
        if(!this.hasOuterPencil(pencil) && this.number == 0) {
            this.outerPencils.add(pencil);
        }
    };
    cell.removeOuterPencil = function(pencil) {
        const index = this.outerPencils.indexOf(pencil);
        if(index > -1) {
            this.outerPencils.splice(index, 1);
        }
    };
    cell.hasOuterPencil = function(pencil) {
        return this.outerPencils.indexOf(pencil) != -1;
    }
}

export function addOrRemoveInnerPencil(data, number) {
    let newData = _.cloneDeep(data);

    let selectedCells = newData.cells.filter(cell => cell.isSelected && cell.number == 0);
    let cellsWithoutPencil = selectedCells.filter(cell => !cell.hasInnerPencil(number));
    if (cellsWithoutPencil.length > 0) {
        cellsWithoutPencil.forEach(cell => cell.innerPencils.push(number));
    } else {
        selectedCells.forEach(cell => cell.removeInnerPencil(number));
    }
    selectedCells.forEach(cell => {cell.innerPencils.sort(); cell.outerPencils.sort()});

    return newData;
}

export function addOrRemoveOuterPencil(data, number) {
    let newData = _.cloneDeep(data);

    let selectedCells = newData.cells.filter(cell => cell.isSelected && cell.number == 0);
    let cellsWithoutPencil = selectedCells.filter(cell => !cell.hasOuterPencil(number));
    if (cellsWithoutPencil.length > 0) {
        cellsWithoutPencil.forEach(cell => cell.outerPencils.push(number));
    } else {
        selectedCells.forEach(cell => cell.removeOuterPencil(number));
    }
    selectedCells.forEach(cell => {cell.innerPencils.sort(); cell.outerPencils.sort()});

    return newData;
}

export function setAnswer(data, number) {
    let newData = _.cloneDeep(data);

    let selectedCells = newData.cells.filter(cell => cell.isSelected && !cell.isGiven && !cell.isCompleted);
    selectedCells.forEach(cell => {
        cell.number = number;
        cell.innerPencils = [];
        cell.outerPencils = [];
    });

    return newData;
}

export function isAnswerSet(data, number) {
    let selectedCells = data.cells.filter(cell => cell.isSelected && !cell.isGiven && !cell.isCompleted && cell.number != number);

    return selectedCells.length == 0;
}

export function selectedCellsHaveData(data) {
    let selectedCells = data.cells.filter(cell => cell.isSelected && !cell.isGiven && 
        (cell.number > 0 || cell.innerPencils.length > 0 || cell.outerPencils.length > 0));

    return selectedCells.length > 0;
}

export function clearCells(data) {
    let newData = _.cloneDeep(data);
    
    let selectedCells = newData.cells.filter(cell => cell.isSelected);
    selectedCells.forEach(cell => {
        if(!cell.isGiven && !cell.isCompleted) {
            cell.innerPencils = [];
            cell.outerPencils = [];
            cell.number = 0;
        }
    });

    return newData;
}